/**
 * Phase 1 paywall copy — sell *their* result, never the demo $61k/$89k couple example.
 */

export function formatIncomeShort(income) {
  const n = Math.round(Number(income) || 0);
  if (!Number.isFinite(n) || n <= 0) return null;
  if (n >= 1000) return `$${Math.round(n / 1000)}k/yr`;
  return `$${n.toLocaleString('en-AU')}/yr`;
}

function survivalPhrase(survivalPct) {
  const n = Number(survivalPct);
  if (!Number.isFinite(n) || n < 0) return null;
  return `${Math.round(n)}% Monte Carlo survival`;
}

/** Primary CTA label for exhausted / post-result surfaces (monthly primary). */
export function subscribeWithTheirNumberLabel(income, { monthlyPrice = '$14.99/mo', survivalPct = null } = {}) {
  const short = formatIncomeShort(income);
  if (short) return `Keep testing your ~${short} plan — from ${monthlyPrice}`;
  const survival = survivalPhrase(survivalPct);
  if (survival) return `Keep testing this ${survival} plan — from ${monthlyPrice}`;
  return `Keep testing this plan — from ${monthlyPrice}`;
}

/** Supporting sentence under exhausted banners. */
export function exhaustedSupportCopy(income, survivalPct = null) {
  const short = formatIncomeShort(income);
  const survival = survivalPhrase(survivalPct);
  if (short) {
    const survivalBit = survival ? ` ${survival}.` : '';
    return `This run supports ~${short}.${survivalBit} Export PDF, stress more start years, and save scenarios with Advanced Retirement.`;
  }
  if (survival) {
    return `This run showed ${survival}. Export PDF, stress more start years, and save scenarios with Advanced Retirement.`;
  }
  return 'Export PDF, stress more start years, and save scenarios with Advanced Retirement.';
}
